import { ApiState, Action } from '../../types';
import { serviceReducer, callService } from '../../shared/hooks/serviceReducer';
import { MissionFilter, MissionList, QueryGroup } from '../../services/types/Missions';

export type MissionAction =
  | Action<MissionList, MissionFilter>
  | {
      type: 'QUERY_GROUP';
      value: QueryGroup;
    }
  | {
      type: 'ASSIGNED';
      value: boolean;
    }
  | { type: 'PAGE'; value: number }
  | { type: 'PAGE_SIZE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<MissionList, MissionFilter>,
  action: MissionAction
): ApiState<MissionList, MissionFilter> => {
  switch (action.type) {
    case 'QUERY_GROUP': {
      const filter = { ...state.filter, queryGroup: action.value, pageNumber: 1 };
      return callService(state, filter);
    }
    case 'ASSIGNED': {
      const filter = { ...state.filter, assigned: action.value, pageNumber: 1 };
      return callService(state, filter);
    }
    case 'PAGE':
      return callService(state, { pageNumber: action.value });
    case 'PAGE_SIZE':
      return callService(state, { pageSize: action.value });
    case 'ORDER':
      return callService(state, { sortField: action.column, sortDescending: action.descending });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
